import React from 'react';

interface IProps {
  children: string | number;
  variant: 'sm' | 'lg';
  className?: string;
}

const smallClasses = 'body-text-xs text-midnight px-2 py-1';
const largeClases = 'body-text-md font-semibold text-abyss px-3.5 py-1.5';

export const Counter = ({ children, variant, className = '' }: IProps) => {
  const classes = variant === 'lg' ? largeClases : smallClasses;
  return (
    <div
      className={`border-twilight inline-block rounded-[24px] border bg-white ${classes} ${className}`}
    >
      {children}
    </div>
  );
};
